import { render } from "./motors.vue?vue&type=template&id=971926c8"
import script from "./motors.vue?vue&type=script&lang=js"
export * from "./motors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__